import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { perpsV1PinsDataProvider } from './dataProvider';

// 注册 perps-v1-pins 模块的数据提供者
export function initPerpsV1PinsDataProvider() {
  registerModuleDataProvider(Resources.perpsV1Pins, perpsV1PinsDataProvider);
}

// 自动初始化
initPerpsV1PinsDataProvider();
